import { TaxonomyPage, TaxonomySection } from 'shared/tracking/contracts';

export const getSegmentData = (pathname: string) => {
    const currentPath = pathname.replace(/(\/\[.+\]$)/, '');

    const keyMap: Record<
        string,
        [keyof typeof TaxonomyPage, keyof typeof TaxonomySection]
    > = {
        '/': ['HOMEPAGE', 'HOMEPAGE'],
        '/home-values': ['HOME_VALUES', 'HOME_VALUES'],
        '/valuation': ['VALUATION', 'HOUSE_PRICES'],
        '/privacy': ['PRIVACY', 'PRIVACY'],
        '/discover': ['DISCOVER', 'DISCOVER'],
        '/for-sale': ['FOR_SALE_SEARCH_RESULTS', 'FOR_SALE'],
        '/for-sale/details': ['FOR_SALE_DETAILS', 'FOR_SALE'],
        '/to-rent': ['TO_RENT_SEARCH_RESULTS', 'TO_RENT'],
        '/to-rent/details': ['TO_RENT_DETAILS', 'TO_RENT'],
        '/new-homes': ['NEW_HOMES_SEARCH_RESULTS', 'NEW_HOMES'],
        '/new-homes/details': ['NEW_HOMES_DETAILS', 'NEW_HOMES'],
        '/property': ['PROPERTY', 'HOUSE_PRICES'],
        '/signin': ['SIGN_IN', 'SIGN_IN'],
        '/register': ['REGISTER', 'REGISTER']
    };

    const pageKey = keyMap[currentPath]
        ? keyMap[currentPath][0]
        : ('HOMEPAGE' as const);
    const sectionKey = keyMap[currentPath]
        ? keyMap[currentPath][1]
        : ('HOMEPAGE' as const);

    return {
        page: TaxonomyPage[pageKey],
        section: TaxonomySection[sectionKey]
    };
};
